<template>
    <div class="flex flex-col justify-center space-y-32">
        <div class="w-full">
            <recruit-process
                ref="recruitProcessGraph"
                :filter-fields="filterFields"
                :class="defaultCardClasses"
            ></recruit-process>
        </div>
        <div class="w-full">
            <div class="w-full flex flex-col xl:flex-row justify-between space-y-32 xl:space-y-0 xl:space-x-32">
                <interviews-statuses
                    class="w-full xl:w-1/2"
                    ref="interviewsStatusesGraph"
                    :filter-fields="filterFields"
                    :class="[defaultCardClasses.replace('w-full', ''), 'flex flex-col justify-between']"
                />
                <interviewed-candidates
                    class="w-full xl:w-1/2"
                    ref="interviewedCandidatesGraph"
                    :filter-fields="filterFields"
                    :class="[defaultCardClasses.replace('w-full', ''), 'flex flex-col justify-between']"
                />
            </div>
        </div>
        <feature
            feature-key="analytics_interviews_per_interviewer"
            class="w-full"
        >
            <interviews-interviewer
                :filterFields="filterFields"
                :class="defaultCardClasses"
            />
        </feature>
        <div class="w-full">
            <stages
                :filter-fields="filterFields"
                :class="defaultCardClasses"
                :default-card-classes="defaultCardClasses"
            />
        </div>
        <div class="w-full">
            <application-reject-reasons
                ref="applicationRejectReasonsGraph"
                :filter-fields="filterFields"
                :class="defaultCardClasses"
            />
        </div>
    </div>
</template>

<script>
// apexcharts imports
import RecruitProcess from './RecruitProcess';
import Stages from "./Stages";
import ApplicationRejectReasons from "./ApplicationRejectReasons.vue";
import InterviewsStatuses from "./InterviewsStatuses.vue";
import InterviewedCandidates from "./InterviewedCandidates.vue";
import Feature from "../Feature.vue";
import InterviewsInterviewer from "./InterviewsInterviewer.vue";

export default {
    name: 'TabRecruitmentProcess',
    components: {
        InterviewsStatuses,
        InterviewedCandidates,
        InterviewsInterviewer,
        Feature,
        ApplicationRejectReasons,
        RecruitProcess,
        Stages,
    },
    props: {
        filterFields: {type: Object},
        defaultCardClasses: {type: String},
    },
    data: function () {
        return {
            selectedJob: null,
            jobs: null,
            loadInterviewCandidates: false,
        }
    },
}
</script>
